import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pogolist" }

import { useStore } from '@/store'
import { computed, ref } from 'vue'
import PogoCard from '@/components/PogoCard.vue'
import { PokedexUpdatePayload } from '@/types/pokedex'
import { PokemonId } from '@/types/pokemon'
import { whenever } from '@vueuse/core'


export default /*#__PURE__*/_defineComponent({
  __name: 'PogoList',
  setup(__props) {

const store = useStore()

const filteredList = computed(() => store.state.filteredList)
const pokemonList = computed(() => store.state.dictionaries.pokemon)
const formList = computed(() => store.state.dictionaries.form)
const pokedex = computed(() => store.state.pokedex)

const updatePokedexEntry = (id: PokemonId, { type, prop, value }: PokedexUpdatePayload) => {
  let t
  switch (type) {
    case 'state' :
      t = 'updatePokedexState'
      break
    case 'genre' :
      t = 'updatePokedexGenre'
      break
    case 'versions' :
      t = 'updatePokedexVersions'
      break
  }
  store.commit(t, {
    id: id,
    prop: prop,
    value: value
  })
}

const visibleCards = ref<PokemonId[]>([])
const cards = ref<typeof PogoCard[] | null>(null)

const observer = new IntersectionObserver((entries) => {
  entries
    .filter(entry => entry.isIntersecting)
    .forEach(entry => {
      visibleCards.value.push(entry.target.id)
      observer.unobserve(entry.target)
    })
}, {
  threshold: 0.2
})

whenever(cards, () => {
  if (!cards.value) return
  cards.value.forEach((card) => {
    observer.observe(card.$el)
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredList), (item) => {
      return (_openBlock(), _createBlock(PogoCard, {
        key: item,
        ref_for: true,
        ref_key: "cards",
        ref: cards,
        pokemon: {
        id: item,
        data: _unref(pokemonList)[item] || _unref(formList)[item],
        entry: _unref(pokedex)[item],
        visible: visibleCards.value.includes(item)
      },
        id: item,
        onUpdate: (d) => updatePokedexEntry(item, d)
      }, null, 8, ["pokemon", "id", "onUpdate"]))
    }), 128))
  ]))
}
}

})